// AppShell — root layout primitive for the LiveVane SPA.
//
// Owns the fixed textured backdrop and cyan/magenta atmosphere
// (painted by `.app-shell-backdrop` in globals.css), the global
// AppHeader, and slots {children} below them.
//
// AppHeader is rendered inside the same `relative z-0` stack as children
// rather than fixed, so it occupies real layout space and never covers
// page content. The header is `sticky top-0` so it remains reachable
// while scrolling long lists.
import type { ReactElement, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { AppHeader } from './app-header'

export interface AppShellProps {
  /** Page content rendered above the backdrop. */
  children: ReactNode
  /** Extra classes applied to the outer wrapper. */
  className?: string
}

export function AppShell({ children, className }: AppShellProps): ReactElement {
  return (
    <div className={cn('relative isolate min-h-dvh text-foreground', className)}>
      <div
        aria-hidden="true"
        className="app-shell-backdrop pointer-events-none fixed inset-0 -z-10"
      />
      <div className="relative z-0">
        <AppHeader />
        {children}
      </div>
    </div>
  )
}

export default AppShell
